import { SideBar } from '../../models/sideBar.model';
import { assets } from './assets.const';

export const accountSideBarConst = {
  MyProfile: 1,
  MyPackages: 2,
  AccountInvoice: 3,
  // PaymentMethod: 4,
  ChangePassword: 5,
  ActivityLogs: 6,
  Settings: 7,
  SignOut: 8,
  DeleteAccount: 9,
  ChangeLanguage: 10
};

export const tutorCounsellorSideBarConst = {
  MyProfile: 1,
  MyAvailability: 2,
  EarningPayroll: 3,
  ChangePassword: 4,
  ActivityLogs: 5,
  Settings: 6,
  SignOut: 7,
  DeleteAccount: 8,
  ChangeLanguage: 9
};

export const SideBar2Const = {
  Communication: 1,
  Notification:2,
  HelpSupport:3
};

export const SideBarTutorConst = {
  Communication: 1,
  Notification:2,
  HelpSupport:3
};


export const sideBar: SideBar[] = [
  {
    text: 'Dashboard',
    path: '/dashboard',
    img: assets.dashboardIcon,
    isSubMenu: false
  },
  {
    text: 'Students',
    path: '/manage-students',
    img: assets.studentIcon4,
    isSubMenu: false
  },
  {
    text: 'Tutoring',
    path: '/manage-tutoring/tutors',
    img: assets.tutoringIcon,
    isSubMenu: false
  },
  {
    text: 'Counselling',
    path: '/manage-counselling/counsellors',
    img: assets.counsellingIcon,
    isSubMenu: false
  },
  {
    text: 'Sessions',
    path: '/manage-session',
    img: assets.sessionIcon,
    isSubMenu: false
  },
  {
    text: 'Resources ',
    path: '/action-plan',
    img: assets.actionIcon,
    isSubMenu: false
  },
  {
    text: 'Calender',
    path: '/calendar',
    img: assets.calendarIcon,
    isSubMenu: false
  },
  {
    text: 'Courses',
    path: '/manage-courses',
    img: assets.coursesIcon,
    isSubMenu: false
  }


];

export const sideBar2: SideBar[] = [
  {
    text: 'Communication',
    path: '/chat',
    img: assets.communicationIcon,
    isSubMenu: false,
    sideBarId:SideBar2Const.Communication
  },
  {
    text: 'Notifications',
    path: '/manage-notification/notification',
    img: assets.notificationIcon,
    isSubMenu: false,
    sideBarId:SideBar2Const.Notification
  },
  {
    text: 'help&support',
    path: '/support',
    img: assets.supportIcon,
    isSubMenu: false,
    sideBarId:SideBar2Const.HelpSupport
  }

];

export const accountSideBar: SideBar[] = [
  {
    text: 'MyProfile',
    path: '/my-profile',
    img: assets.profileIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.MyProfile
  },
  {
    text: 'MyPackages',
    path: '/manage-tutoring/tutor-package',
    img: assets.profileIcon2,
    isSubMenu: false,
    sideBarId: accountSideBarConst.MyPackages
  },
  {
    text: 'Account&Invoices',
    path: '/my-profile/account-invoice',
    img: assets.profileIcon3,
    isSubMenu: false,
    sideBarId: accountSideBarConst.AccountInvoice
  },
  // {
  //   text: 'PaymentMethods',
  //   path: '/my-profile/payment-method',
  //   img: assets.paymentMethod,
  //   isSubMenu: false,
  //   sideBarId: accountSideBarConst.PaymentMethod
  // },
  {
    text: 'ChangePassword',
    path: '/my-profile/change-password',
    img: assets.profileIcon5,
    isSubMenu: false,
    sideBarId: accountSideBarConst.ChangePassword
  },
  {
    text: 'Activitylogs',
    path: '/my-profile/activity-logs',
    img: assets.profileIcon6,
    isSubMenu: false,
    sideBarId: accountSideBarConst.ActivityLogs
  },
  {
    text: 'ChangeLanguage',
    path: '/my-profile/change-language',
    img: assets.changeLanguageIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.ChangeLanguage
  },
  {
    text: 'Settings',
    path: '/manage-setting',
    img: assets.settingIcon1,
    isSubMenu: false,
    sideBarId: accountSideBarConst.Settings
  },
  {
    text: 'SignOut',
    path: '/auth/login',
    img: assets.signOutIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.SignOut
  },
  {
    text: 'DeleteAccount',
    path: '/auth/login',
    img: assets.trashIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.DeleteAccount
  }

];

export const tutorCounsellorSideBar: SideBar[] = [
  {
    text: 'MyProfile',
    path: '/tutor/profile',
    img: assets.profileIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.MyProfile
  },
  {
    text: 'MyAvailability',
    path: '/tutor/profile/availability',
    img: assets.profileIcon2,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.MyAvailability
  },
  {
    text: 'Earnings&Payroll',
    path: '/tutor/dashboard/earning',
    img: assets.profileIcon3,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.EarningPayroll
  },
  {
    text: 'ChangePassword',
    path: '/tutor/profile/change-password',
    img: assets.profileIcon5,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.ChangePassword
  },
  {
    text: 'Activitylogs',
    path: '/tutor/profile/activity-logs',
    img: assets.profileIcon6,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.ActivityLogs
  },
  {
    text: 'ChangeLanguage',
    path: '/tutor/profile/change-language',
    img: assets.changeLanguageIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.ChangeLanguage
  },
  {
    text: 'Settings',
    path: '/tutor/manage-setting',
    img: assets.settingIcon1,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.Settings
  },
  {
    text: 'SignOut',
    path: '/auth/login',
    img: assets.signOutIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.SignOut
  },
  {
    text: 'DeleteAccount',
    path: '/auth/login',
    img: assets.trashIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.DeleteAccount
  }

];


export const settingSideBar: SideBar[] = [
  {
    text: 'AboutUs',
    path: '/manage-setting/about-us',
    img: assets.aboutIcon,
    isSubMenu: false
  },
  {
    text: 'Terms&Conditions',
    path: '/manage-setting/term-and-condition',
    img: assets.termIcon,
    isSubMenu: false
  },
  {
    text: 'PrivacyPolicy',
    path: '/manage-setting/privacy-policy',
    img: assets.privacyIcon,
    isSubMenu: false
  },
  {
    text: 'DeletionPolicy',
    path: '/manage-setting/deletion-policy',
    img:  assets.trashIcon,
    isSubMenu: false
  },
  {
    text: 'FAQs',
    path: '/manage-setting/faq',
    img: assets.faqIcon,
    isSubMenu: false
  }

];


export const sideBartutor4: SideBar[] = [
  {
    text: 'AboutUs',
    path: '/tutor/manage-setting/about-us',
    img: assets.aboutIcon,
    isSubMenu: false
  },
  {
    text: 'Terms&Conditions',
    path: '/tutor/manage-setting/term-and-condition',
    img: assets.termIcon,
    isSubMenu: false
  },
  {
    text: 'PrivacyPolicy',
    path: '/tutor/manage-setting/privacy-policy',
    img: assets.privacyIcon,
    isSubMenu: false
  },
  {
    text: 'DeletionPolicy',
    path: '/manage-setting/deletion-policy',
    img: assets.delete_icon1,
    isSubMenu: false
  },
  {
    text: 'FAQs',
    path: '/tutor/manage-setting/faq',
    img: assets.faqIcon,
    isSubMenu: false
  }


];


export const sideBarTutor1: SideBar[] = [
  {
    text: 'Dashboard',
    path: '/tutor/dashboard',
    img: assets.dashboardIcon,
    isSubMenu: false
  },
  {
    text: 'Students',
    path: '/tutor/manage-students',
    img: assets.studentIcon4,
    isSubMenu: false
  },
  {
    text: 'Calender',
    path: '/tutor/calendar',
    img: assets.calendarIcon,
    isSubMenu: false
  },
  {
    text: 'Sessions',
    path: '/tutor/manage-session',
    img: assets.sessionIcon,
    isSubMenu: false
  },
  {
    text: 'Resources',
    path: '/tutor/action-plan',
    img: assets.actionIcon,
    isSubMenu: false
  },
  {
    text: 'Courses',
    path: '/tutor/manage-courses',
    img: assets.coursesIcon,
    isSubMenu: false
  }


];

export const sideBarTutor2: SideBar[] = [
  {
    text: 'Communication',
    path: '/chat',
    sideBarId:SideBarTutorConst.Communication,
    img: assets.communicationIcon,
    isSubMenu: false
  },
  {
    text: 'Notifications',
    path: '/tutor/manage-notification',
    sideBarId:SideBarTutorConst.Notification,
    img: assets.notificationIcon,
    isSubMenu: false
  },
  {
    text: 'help&support',
    path: '/tutor/support',
    sideBarId:SideBarTutorConst.HelpSupport,
    img: assets.supportIcon,
    isSubMenu: false
  }
];


